import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/settings.svg';

export const IconSettings = createIconComponent(Icon);
